/**
 * All story text in Romanian. {p1} / {p2} placeholders are replaced at render time
 * so custom names from the Player Names screen flow through naturally.
 */

export const INTRO_LINES: string[] = [
  'În Regatul Elevarta, totul era pace...',
  'Până când Regele PIEROS, stăpânul bombelor întunecate,',
  'a răpit-o pe Prințesă și a închis-o în Castelul de Foc.',
  'Doi frați curajoși, {p1} și {p2}, pornesc în salvarea ei.',
  '',
  'Apasă SPACE pentru a începe aventura...',
];

interface WorldStory {
  intro: string[];
  outro: string[];
}

export const WORLD_STORY: Record<number, WorldStory> = {
  1: {
    intro: ['Câmpia Verde.', '{p1} și {p2} își aprind primele fitiluri.', 'Țestoasele blochează drumul...'],
    outro: ['Ați supraviețuit Câmpiei!', 'Dar PIEROS râde din peșteri...'],
  },
  2: {
    intro: ['Peștera Cristalină.', 'Cristalele reflectă fiecare bombă.', 'Lilieci explozivi vânează din întuneric.'],
    outro: ['Peștera a fost cucerită.', 'Dincolo se aude foșnetul pădurii întunecate...'],
  },
  3: {
    intro: ['Pădurea Întunecată.', 'Creaturile aici sunt mai inteligente.', '{p1} șoptește: rămâi aproape, {p2}.'],
    outro: ['Pădurea v-a încercat — și ați câștigat.', 'Castelul de Foc se înalță la orizont.'],
  },
  4: {
    intro: ['Castelul de Foc.', 'Arde de o mie de ani.', 'Dragonii păzesc fiecare coridor.'],
    outro: ['Castelul de Foc a căzut.', 'Sub el — Insula Plutitoare.'],
  },
  5: {
    intro: ['Insula Plutitoare.', 'Sus în cer, gravitația joacă feste.', 'Norii furtunoși urlă în spatele lui {p1} și {p2}.'],
    outro: ['Furtuna s-a liniștit.', 'Departe, în vale, mlaștina îi cheamă.'],
  },
  6: {
    intro: ['Mlaștina Otrăvii.', 'Mocirla rămâne lipită de tălpi.', 'Crocodilii toxici așteaptă răbdători.'],
    outro: ['Mlaștina s-a uscat în urma voastră.', 'Înainte — ruinele unei civilizații pierdute.'],
  },
  7: {
    intro: ['Orașul Ruinat.', 'Mașinării vechi încă funcționează.', 'Roboții vânători nu uită nimic.'],
    outro: ['Orașul a tăcut.', 'Vântul rece anunță tundra.'],
  },
  8: {
    intro: ['Tundra de Gheață.', 'Frigul îi încetinește pe {p1} și {p2}.', 'Dar bombele lor ard la fel de tare.'],
    outro: ['Gheața s-a topit.', 'Aerul devine fierbinte — vulcanul e aproape.'],
  },
  9: {
    intro: ['Vulcanul Activ.', 'Lava urmărește cu răbdare.', 'Phoenixul Bombelor renaște din cenușă.'],
    outro: ['Phoenixul a căzut definitiv.', 'În depărtare se vede Castelul lui PIEROS.'],
  },
  10: {
    intro: ['Castelul Pieros.', 'Ultima bătălie.', 'Prințesa îi așteaptă pe {p1} și {p2}.'],
    outro: [], // outro pentru W10 = VictoryScene
  },
};

export const FINAL_LINES: string[] = [
  'PIEROS cade. Castelul se cutremură.',
  'Prințesa Elevarta este liberă.',
  '— Mulțumesc, {p1}. Mulțumesc, {p2}.',
  'Aventura voastră va fi spusă pentru totdeauna.',
  '',
  '🎉 BOMBASTIK COMPLET 🎉',
];

export function interpolate(line: string, p1Name: string, p2Name: string): string {
  return line.split('{p1}').join(p1Name).split('{p2}').join(p2Name);
}
